var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "url(#paint0_linear_2173_20490)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3611 39L33.0411 15.32H20.7211V10.2H38.8811V15.32L29.2411 39H23.3611Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 61.3148C43.5 54.377 33.4768 50.7962 30.094 44.3619L29.9687 44.25L29.906 44.3619C26.5232 50.7962 16.5 54.377 16.5 61.3148C16.5 67.1337 25.0824 69.3717 29.2796 64.504C29.3422 64.2802 29.2796 66.0706 28.9664 67.0777C27.964 70.0431 24.3306 74.4072 22.5766 75.75C25.0197 73.9036 34.855 73.9036 37.2981 75.75C35.5441 74.4072 32.0986 70.2109 30.9084 67.0777C30.6578 66.1825 30.5325 65.3432 30.4698 64.448C34.6044 69.7074 43.5 67.2456 43.5 61.3148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_20490",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7S);
export default __webpack_public_path__ + "static/media/7s.2a7142d229e97860f63750a771262c7f.svg";
export { ForwardRef as ReactComponent };